module.exports = __webpack_public_path__ + "12606d3b74ceecc4db00ea7f2878ab42.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/I1@2x.png
// module id = 817
// module chunks = 0